/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime.js';
import { AncillaryFromJSON, AncillaryToJSON, } from './Ancillary.js';
import { CfarItinerarySliceFromJSON, CfarItinerarySliceToJSON, } from './CfarItinerarySlice.js';
import { CfarPassengerFromJSON, CfarPassengerToJSON, } from './CfarPassenger.js';
import { FareRuleFromJSON, FareRuleToJSON, } from './FareRule.js';
import { PassengerPricingFromJSON, PassengerPricingToJSON, } from './PassengerPricing.js';
/**
 * Check if a given object implements the CfarCreateExerciseItinerary interface.
 */
export function instanceOfCfarCreateExerciseItinerary(value) {
    let isInstance = true;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "slices" in value;
    return isInstance;
}
export function CfarCreateExerciseItineraryFromJSON(json) {
    return CfarCreateExerciseItineraryFromJSONTyped(json, false);
}
export function CfarCreateExerciseItineraryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'passengerPricing': !exists(json, 'passenger_pricing') ? undefined : (json['passenger_pricing'].map(PassengerPricingFromJSON)),
        'currency': json['currency'],
        'slices': (json['slices'].map(CfarItinerarySliceFromJSON)),
        'ancillaries': !exists(json, 'ancillaries') ? undefined : (json['ancillaries'].map(AncillaryFromJSON)),
        'totalPrice': !exists(json, 'total_price') ? undefined : json['total_price'],
        'passengers': !exists(json, 'passengers') ? undefined : (json['passengers'].map(CfarPassengerFromJSON)),
        'fareRules': !exists(json, 'fare_rules') ? undefined : (json['fare_rules'].map(FareRuleFromJSON)),
    };
}
export function CfarCreateExerciseItineraryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'passenger_pricing': value.passengerPricing === undefined ? undefined : (value.passengerPricing.map(PassengerPricingToJSON)),
        'currency': value.currency,
        'slices': (value.slices.map(CfarItinerarySliceToJSON)),
        'ancillaries': value.ancillaries === undefined ? undefined : (value.ancillaries.map(AncillaryToJSON)),
        'total_price': value.totalPrice,
        'passengers': value.passengers === undefined ? undefined : (value.passengers.map(CfarPassengerToJSON)),
        'fare_rules': value.fareRules === undefined ? undefined : (value.fareRules.map(FareRuleToJSON)),
    };
}
